import React, { useCallback, useEffect, useState } from 'react'
import useApi from '../../hooks/useApi'
import { Diagnosis } from '../../types/Diagnosis'
import DiagnosesCard from '../DiagnosesCard'

import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

// Import Swiper styles
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'
import 'swiper/modules/navigation/navigation.min.css'

import SwiperCore, {
    Pagination,
    Navigation
} from 'swiper';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from 'react-icons/fa';

SwiperCore.use([Navigation, Pagination]);

export const DiagnosesAnswered = () => {


    const api = useApi()

    const [diagnoses, setDiagnoses] = useState<Diagnosis[]>()

    const loadDiagnoses = useCallback(async () => {
        await api.get("/client/diagnoses", { params: { answer: true } }).then(res => {
            setDiagnoses(res.data)
        }).catch(console.log)
    }, [api])

    useEffect(() => {
        loadDiagnoses()
    }, [loadDiagnoses])

    return (
        <div className='my-2'>
            <div className='text-gray-600 font-semibold'>Testes respondidos</div>
            {
                diagnoses?.length === 0 &&
                <div className='w-full text-center text-gray-600 font-semibold'> Sem teste respondidos</div>

            }

            <Swiper
                spaceBetween={15}
                freeMode={true}
                slidesPerView={3}
                modules={[Navigation, Pagination]}
                navigation={{
                    prevEl: '.noreply-prev',
                    nextEl: '.noreply-next',

                }}
                pagination={{
                    el: '.noreply-pagination',
                    type: 'bullets',
                }}
                autoplay={{
                    delay: 5000,
                }}
                className="mySwiper">
                {diagnoses && diagnoses.map(item => (
                    <SwiperSlide key={item.id}>
                        <DiagnosesCard diagnosis={item} answeredAt={item.replyAt ? item.replyAt : ""} />
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className='flex justify-between my-2  items-center'>
                <div>
                    <div className='noreply-pagination flex gap-x-1'></div>
                </div>
                <div className='flex'>
                    <div className='noreply-prev prev-slide' ><FaArrowAltCircleLeft className='text-blue-700  text-lg mr-1' /></div>
                    <div className='noreply-next next-slide' ><FaArrowAltCircleRight className='text-blue-700 text-lg ' /></div>
                </div>
            </div>
        </div>
    )
}
